module.exports = __webpack_public_path__ + "assets/529859264347215a437c0cb0d198ccfe.mp3";